// Dynamic district atmosphere: time-of-day (from the user's real local clock)
// + a daily weather mood (stable within a calendar day, different day-to-day and
// per-pillar) so the scene is never the same.

export const timePhase = (d = new Date()) => {
  const h = d.getHours();
  if (h >= 5 && h < 8) return 'dawn';
  if (h >= 8 && h < 11) return 'morning';
  if (h >= 11 && h < 16) return 'midday';
  if (h >= 16 && h < 19) return 'dusk';
  return 'night';
};

export const PHASE_LABEL = {
  dawn: 'Dawn', morning: 'Morning', midday: 'Midday', dusk: 'Golden hour', night: 'Night',
};

const WEATHERS = ['clear', 'partly-cloudy', 'overcast', 'light-rain', 'fog', 'crisp'];

export const WEATHER_LABEL = {
  clear: 'Clear skies', 'partly-cloudy': 'Partly cloudy', overcast: 'Overcast',
  'light-rain': 'Light rain', fog: 'Misty', crisp: 'Crisp & bright',
};

// FNV-1a hash on YYYY-M-D-pillar → deterministic weather that only changes at midnight.
export const dailyWeather = (pillar = '', d = new Date()) => {
  const key = `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}-${pillar}`;
  let h = 2166136261;
  for (let i = 0; i < key.length; i++) { h ^= key.charCodeAt(i); h = Math.imul(h, 16777619); }
  return WEATHERS[(h >>> 0) % WEATHERS.length];
};

// Health-driven weather: the pillar's wellness score picks a MOOD band (same 4
// states as the avatar), then a daily seed varies the exact sky within that band
// so it reflects how you're doing AND still differs day-to-day.
const WEATHER_BY_STATE = {
  poor:      ['light-rain', 'fog', 'overcast'],
  fair:      ['overcast', 'partly-cloudy', 'fog'],
  good:      ['partly-cloudy', 'clear', 'crisp'],
  excellent: ['clear', 'crisp', 'partly-cloudy'],
};

export const scoreState = (score) =>
  score == null ? 'fair' : score < 40 ? 'poor' : score < 60 ? 'fair' : score < 80 ? 'good' : 'excellent';

export const healthWeather = (score, pillar = '', d = new Date()) => {
  const pool = WEATHER_BY_STATE[scoreState(score)];
  const key = `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}-${pillar}`;
  let h = 2166136261;
  for (let i = 0; i < key.length; i++) { h ^= key.charCodeAt(i); h = Math.imul(h, 16777619); }
  return pool[(h >>> 0) % pool.length];
};
